module.exports = __webpack_public_path__ + "static/media/SkullBasher.6aee0222.png";